<template>
  <div class="tab-content pa-4 scroll-fire-fox">
    <v-layout wrap justify-space-between align-start>
      <v-flex xs12 md4 style="height: fit-content">
        <network-starting-point
          :is-fixed="true"
          :disabled="validationsAreRunning"
        />
      </v-flex>

      <v-flex xs12 md8 style="height: fit-content" />

      <v-flex xs12 md4 class="mt-4">
        <validation-selection
          @updateRunState="validationsAreRunning = $event"
          @selectResults="selectedResults = $event"
        />
      </v-flex>

      <v-flex xs12 md7 class="mt-4">
        <error-selection
          v-if="selectedResults"
          :selected-results="selectedResults"
        />
        <v-card
          v-else
          color="white"
          style="color: var(--v-secondary-darken1)"
          height="100%"
        >
          <v-layout fill-height column justify-center align-center class="pa-5">
            <div class="message-title">
              {{ $t("NoValidationResultsSelected") }}
            </div>
            <div class="message-description">
              {{ $t("RunValidationSelectResults") }}
            </div>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import NetworkStartingPoint from "../StartingPoint/StartingPoint";
import ValidationSelection from "./ValidationSelection/ValidationSelection";
import ErrorSelection from "./ErrorSelection/ErrorSelection";

export default {
  name: "Validation",

  components: { ErrorSelection, ValidationSelection, NetworkStartingPoint },

  data() {
    return {
      validationsAreRunning: false,
      selectedResults: undefined
    };
  }
};
</script>

<style scoped>
.tab-content {
  width: 100%;
  height: 100%;
  background: var(--v-secondary-lighten1);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Validations/ValidationsTab.vue